import { styled, Typography, Box, Button, Tab } from "@mui/material";

export const StyledTabsWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
});

export const StyledBox = styled(Box)({
  width: "100%",
});

export const StyledTabComponent = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasSubTabs",
})(({ theme, hasSubTabs = false }) => ({
  marginTop: hasSubTabs ? "90px" : "65px",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    marginTop: hasSubTabs ? "112px" : "56px",
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  [theme.breakpoints.down(480)]: {
    marginTop: hasSubTabs ? "104px" : "48px",
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  height: "60px",
  minHeight: "48px",
  color: "#344767",
  fontWeight: 600,
  fontSize: "1rem",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  "&.Mui-selected": {
    color: "#1a6beb",
  },
  [theme.breakpoints.down("sm")]: {
    height: "48px",
    minHeight: "44px",
    fontSize: "0.875rem",
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  [theme.breakpoints.down(480)]: {
    minWidth: "auto",
    fontSize: "0.8125rem",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

export const StyledHeaderButton = styled(Button)(({ theme }) => ({
  marginRight: 16,
  textTransform: "none",
  color: "#1a6beb",
  flexShrink: 0,
  [theme.breakpoints.down("sm")]: {
    marginRight: 8,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    fontSize: "0.875rem",
  },
  [theme.breakpoints.down(480)]: {
    marginRight: 4,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    fontSize: "0.8125rem",
  },
}));

export const StyledText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "20px",
  lineHeight: "20px",
  color: "#344767",
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
    lineHeight: "20px",
  },
  [theme.breakpoints.down(480)]: {
    fontSize: "14px",
    lineHeight: "18px",
  },
}));

export const StyledHeadingWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#0d47a1",
  color: "#fff",
  paddingLeft: "20px",
  paddingRight: "36px",
  paddingTop: "10px",
  paddingBottom: "10px",
  marginRight: "8px",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
  clipPath: "polygon(0 0, 100% 0, 100% 0, calc(100% - 20px) 50%, 100% 100%, 100% 100%, 0 100%)",
  "& .MuiTypography-root": {
    color: "#fff",
  },
  [theme.breakpoints.down("sm")]: {
    paddingLeft: 12,
    paddingRight: 20,
    paddingTop: 8,
    paddingBottom: 8,
    marginRight: 4,
    clipPath: "polygon(0 0, 100% 0, 100% 0, calc(100% - 14px) 50%, 100% 100%, 100% 100%, 0 100%)",
  },
  [theme.breakpoints.down(480)]: {
    paddingLeft: 8,
    paddingRight: 12,
    paddingTop: 6,
    paddingBottom: 6,
    marginRight: 4,
    clipPath: "none",
  },
}));

const getTabsBarBoxStyles = (theme) => ({
  position: "fixed",
  left: 0,
  right: 0,
  zIndex: 1001,
  backgroundColor: theme.palette.background.paper,
  width: "100%",
  paddingRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  borderBottom: `1px solid ${theme.palette.divider}`,
  height: "60px",
  display: "flex",
  alignItems: "center",
  top: "65px",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    height: "48px",
    top: "56px",
    paddingLeft: 4,
    paddingRight: 4,
  },
  [theme.breakpoints.down(480)]: {
    height: "48px",
    top: "48px",
    paddingLeft: 2,
    paddingRight: 2,
  },
});

export const StyledTabsBarBox = styled(Box)(({ theme }) => ({
  ...getTabsBarBoxStyles(theme),
}));

export const StyledHeadingTabsGroup = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flex: 1,
  minWidth: 0,
  gap: "24px",
  [theme.breakpoints.down("sm")]: {
    gap: 12,
  },
  [theme.breakpoints.down(480)]: {
    gap: 4,
  },
}));
